import {
  createTheme,
  rem,
  Button,
  Card,
  Input,
  InputWrapper,
  Text,
  SegmentedControl,
  Modal,
  Skeleton,
} from '@mantine/core';

export const theme = createTheme({
  fontFamily:
    '"Inter", -apple-system, BlinkMacSystemFont, Segoe UI, Inter, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif',
  colors: {
    aprioriPurple: [
      '#7C4DFF',
      '#B94DFF',
      '#8136af',
      '#764e9f',
      '#6b6690',
      '#5f7eb1',
      '#4a96c2',
      '#35aed3',
      '#20c7e4',
      '#180e3f',
    ],
    dark: [
      '#ffffff',
      '#F1EDFD',
      '#87868C',
      '#535258',
      '#302F34',
      '#1D1C20',
      '#0F0E12',
      '#080709',
      '#040305',
      '#0a0b0d',
    ],
  },
  defaultGradient: {
    deg: 225,
    from: 'rgba(185, 77, 255, var(--button-bg-opacity, 1))',
    to: 'rgba(124, 77, 255, var(--button-bg-opacity, 1))',
  },
  primaryColor: 'aprioriPurple',
  primaryShade: 0,
  black: '#0a0b0d',
  white: '#ffffff',
  fontSizes: {
    xs: rem(14),
    sm: rem(16),
    md: rem(20),
    lg: rem(24),
    xl: rem(32),
  },
  components: {
    Text: Text.extend({
      defaultProps: { size: 'xs', c: 'var(--mantine-color-main-0)', fw: 500 },
    }),
    Skeleton: Skeleton.extend({
      defaultProps: {
        // @ts-ignore-next-line
        component: 'span',
        display: 'block',
      },
    }),
    Button: Button.extend({
      defaultProps: { size: 'sm' },
      vars: (_, props) => {
        if (props.size === 'sm') {
          return {
            root: {
              '--button-height': rem(40),
              '--button-padding-x': rem(16),
              '--button-radius': rem(90),
              '--button-fz': rem(14),
            },
          };
        }

        if (props.size === 'lg') {
          return {
            root: {
              '--button-height': rem(56),
              '--button-padding-x': rem(16),
              '--button-radius': rem(16),
              '--button-fz': rem(16),
            },
          };
        }

        return { root: {} };
      },
      classNames: {
        label: 'font-[700]',
        root: 'hover:[--button-bg-opacity:0.7] disabled:[background:var(--button-bg)] disabled:text-main0 disabled:[--button-bg-opacity:0.25]',
      },
    }),
    Card: Card.extend({
      classNames: {
        root: 'rounded-[16px] bg-brandblack border border-solid border-white/[.14]',
      },
    }),
    Input: Input.extend({
      vars: (_, props) => {
        if (props.size === 'md') {
          return {
            wrapper: {
              '--input-height': rem(56),
            },
          };
        }

        return { wrapper: {} };
      },
      classNames: {
        input:
          'px-4 rounded-[16px] bg-transparent placeholder:text-[#87868C] placeholder:font-[700] text-white font-[700]',
      },
    }),
    InputWrapper: InputWrapper.extend({
      classNames: {
        root: 'leading-[1]',
        label: 'mb-2 font-[500] text-xs text-main0',
      },
    }),
    SegmentedControl: SegmentedControl.extend({
      classNames: {
        root: 'h-10 p-0 rounded-[12px] outline outline-primarypurple outline-1',
        indicator: 'bg-primarypurple rounded-none',
        label:
          'h-full py-0 px-6 leading-[40px] data-[active]:font-[700] capitalize',
      },
    }),
    Modal: Modal.extend({
      defaultProps: {
        size: 720,
      },
      classNames: {
        content:
          'py-6 px-12 border border-solid border-white/[0.14] rounded-[16px]',
        header:
          'p-0 min-h-0 pb-6 mb-6 border-solid border-0 border-b border-b-white/[0.14]',
        body: 'p-0',
      },
    }),
  },
});
